<template>
    <table class="table table-hover table-bordered table-md">
        <thead>
            <tr>
                <th>#</th>
                <th>Pelanggan/Tanggal</th>
                <th>Nomor Transaksi</th>
                <th>Produk</th>
                <th>Kuantitas</th>
                <th>Satuan</th>
                <th>Harga Satuan USD</th>
                <th>Harga Satuan IDR</th>
                <th>Jumlah Tagihan USD </th>
                <th>Jumlah Tagihan IDR </th>
                <th>Total USD </th>
                <th>Total IDR </th>
                <th></th>
            </tr>
        </thead>
        <tbody>
        <template v-for="item in dataList">
            <tr :key="item.id_kontak">
                <th></th>
                <th colspan="11">{{item.main.display_name}}</th>
            </tr>
            <template v-for="prList in item.main.produkList">
                <tr :key="prList.id_transaksi_produk">
                    <td></td>
                    <td> {{ prList.tanggal_pengiriman | moment("DD MMMM YYYY") }} </td>
                    <td> {{ prList.nomor_pengiriman }} </td>
                    <td> {{ prList.nama_produk }} </td>
                    <td> {{ prList.qty }} </td>
                    <td> {{ prList.nama_satuan }} </td>
                    <td> {{ '$ '+ currencyFormat(prList.harga_satuan) }} </td>
                    <td> {{ 'Rp. '+ currencyFormat(prList.harga_satuan_idr) }} </td>
                    <td> {{ '$ '+ currencyFormat(prList.harga_total) }} </td>
                    <td> {{ 'Rp. '+ currencyFormat(prList.harga_total_idr) }} </td>
                    <td> {{ '$ '+ currencyFormat(prList.totalUsd) }} </td>
                    <td> {{ 'Rp. '+ currencyFormat(prList.totalIdr) }} </td>
                    <td> <a :href="'Transaksi/getSuratJalanProgress/'+prList.id_transaksi_progress" target="_blank" class="btn btn-icon icon-left btn-light"><i class="fas fa-truck"></i> Surat Jalan</a> </td>
                </tr>
            </template>
            <template>
                <tr>
                    <th colspan="10">

                    </th>
                    <th>
                        {{ '$ '+ currencyFormat(item.main.grand_total_usd) }}
                    </th>
                    <th>
                        {{ 'Rp. '+ currencyFormat(item.main.grand_total_idr) }}
                    </th>
                </tr>
            </template>
        </template>
        </tbody>
    </table>
</template>

<script>
import Vue from 'vue'

export default {
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    methods: {
        currencyFormat: function(val){
            console.log(val)
            return this.$parent.currencyFormat(val)
        },
    },
    props : ['dataList']
}
</script>


// WEBPACK FOOTER //
// src/components/laporan/TablePelanggan.vue